import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageBody, PageHead, Tabs } from '../../components/aa';
import RoleManagement from '../consultant/RoleManagement';
import ClientIntake from '../partner/ClientIntake';

const TABS = [
  { id: 'roles', label: 'Roles' },
  { id: 'intake', label: 'Intake Studio' },
];

const SUB: Record<string, string> = {
  roles: 'Who can do what inside a client company.',
  intake: 'The questions every client starts with. Partners keep the opening questions and can change the rest.',
};

const RolesAndIntake: React.FC = () => {
  const [params, setParams] = useSearchParams();
  let active = 'roles';
  if (params.get('tab') === 'intake') active = 'intake';

  return (
    <PageBody>
      <PageHead eyebrow="Business · Settings" title="Roles and intake" sub={SUB[active]} />
      <Tabs
        tabs={TABS}
        active={active}
        onChange={(id) => setParams({ tab: id }, { replace: true })}
        label="Roles and intake"
        variant="pills"
      />
      {active === 'roles' && <RoleManagement />}
      {active === 'intake' && <ClientIntake embedded />}
    </PageBody>
  );
};

export default RolesAndIntake;
